import React from 'react';
import { SchematicShell, ToeKickLine } from './SchematicPrimitives';

/**
 * Corner-fill cabinet — kite-shaped polygon between two cabinet walls
 * at a non-right-angle joint. The elevation projection collapses it to
 * a narrow blank face with no door split, since there is no real
 * cabinet front (just a wedge of carcass behind matching panel). Match
 * adjacent cabinet height by relying on the caller's bounding box;
 * draw only the outer frame + the toe-kick stroke at the bottom.
 *
 * Side views: filler wedge — a depth×height rectangle with toe-kick.
 * Essentially featureless. Symmetric left ↔ right.
 *
 * No variant fields needed — `corner-fill-cabinet` is always the
 * blank-face wedge per buildCornerFillCountertop.js.
 */
export function CornerFillCabinetSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const isSide = view === 'left' || view === 'right';
  const w = isSide ? depth : width;
  return (
    <SchematicShell
      width={w}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      <ToeKickLine
        width={w}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </SchematicShell>
  );
}
CornerFillCabinetSchematic.supportsSideViews = true;
// A filler wedge is blank on both faces.
CornerFillCabinetSchematic.supportsBackView = true;
